var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization',{attrs:{"permissionKey":"island_pre_exam_queue","can":"read"}},[(_vm.attendancePlace)?_c('Attendances',{attrs:{"queueType":"pre_exam","attendancePlaceId":_vm.attendancePlace.id,"pollInterval":60000}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }